export default __webpack_public_path__ + "static/media/1448.a0f4d43f.png";